export async function getAllPagesOperation(setData:Function) {
    console.log('Operations.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'data';

    let data = new FormData();
    return await fetch(reactAppData.api_url+endPoint, {body:data, method:'post'})
        .then(res => res.json())
        .then(
            (result) => {
                setData(result);
            },
            (error) => {
                setData(error);
            }
        );
}
